import React from 'react';
import { X } from 'lucide-react';
import type { ConfigurePermissionsModalProps } from '../types/createGroup';

const ConfigurePermissionsModal: React.FC<ConfigurePermissionsModalProps> = ({
  isOpen,
  groupName,
  onSkip,
  onConfigure,
  onClose
}) => {
  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="configure-permissions-modal-backdrop" onClick={handleBackdropClick}>
      <div className="configure-permissions-modal-container">
        <div className="configure-permissions-modal-header">
          <h2 className="configure-permissions-modal-title">Configure Permissions</h2>
          <button
            className="configure-permissions-modal-close"
            onClick={onClose}
          >
            <X size={20} />
          </button>
        </div>
        
        <div className="configure-permissions-modal-body">
          <div className="configure-permissions-content">
            <div className="configure-permissions-success">
              <p className="configure-permissions-success-text">
                Group <strong>"{groupName}"</strong> has been created successfully.
              </p>
            </div>
            
            <div className="configure-permissions-question">
              <p className="configure-permissions-question-text">
                Would you like to configure permissions now or skip this step?
              </p>
            </div>
            
            <div className="configure-permissions-actions">
              <button
                type="button"
                onClick={onSkip}
                className="configure-permissions-btn-skip"
              >
                Skip
              </button>
              
              <button
                type="button"
                onClick={onConfigure}
                className="configure-permissions-btn-configure"
              >
                Configure
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfigurePermissionsModal;